import { useEffect, useState } from 'react'
import { AppsApi, App } from '../../api/apps'
import { useAuth } from 'torqcloud-ui'
import { AuthenticatedApi } from '../../lib/http'

const useDataApps = () => {
  const [apps, setApps] = useState<App[]>([])
  const authContext = useAuth()
  useEffect(() => {
    const loadDataApps = async () => {
      const appsApi = new AppsApi(new AuthenticatedApi(authContext.authenticationManager))
      const apps = await appsApi.list({})
      setApps(apps)
    }
    void loadDataApps()
  }, [authContext])

  return apps
}

export default useDataApps
